const o = (typeof window == "undefined" ? !1 : /iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1) && // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
!window.MSStream;
function t() {
  return o;
}
export {
  t as default,
  o as isIos
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vooks@0.2.12_vue@3.5.18/~/vooks/es/use-is-ios.js
// module id = 1737
// module chunks = 41